// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__sCMqk","rotate":"style_rotate__RCYsL","laptop":"style_laptop__UgHJo"};